import { createAsyncThunk } from "@reduxjs/toolkit";
import { companySliceName } from "..";
import server from "../../../../config/server";

export const insertSubjectAction = createAsyncThunk(`${companySliceName}/insertSubject`, async (data) => {
  const response = await server.post("/app/subject", data);
  return response.data;
});

export const updateSubjectAction = createAsyncThunk(`${companySliceName}/updateSubject`, async (data) => {
  const response = await server.put("/app/subject", data);
  return response.data;
});

export const getSubjectsAction = createAsyncThunk(`${companySliceName}/getSubjects`, async (_, thunkAPI) => {
  try {
    const response = await server.get("/app/subject/views", {}, {});
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const deleteSubjectAction = createAsyncThunk(`${companySliceName}/deleteSubject`, async (uuid) => {
  const response = await server.delete(`/app/subject?uuid=${uuid}`);
  return response.data;
});